import FetchBeneficiary from '@Application/Beneficiaries/Beneficiaries/Queries/FetchBeneficiary';
import fetchBeneficiary from '@Application/Beneficiaries/Beneficiaries/fetchBeneficiary';
import useStrictCurrentFacility from '@UI/Providers/CurrentFacilityProvider/useStrictCurrentFacility';
import { useDispatch, useStoreQuery } from '@verclam/synapse';

/**
 * True only once the dossier `beneficiaryId` is loaded in the store and is not archived. Fails closed:
 * while the dossier is unknown (or the store holds another one), or when its read fails, write actions
 * stay hidden.
 */
const useIsBeneficiaryEditable = (beneficiaryId: number | null): boolean => {
	const dispatch = useDispatch();
	const { currentFacility } = useStrictCurrentFacility();
	const facilityId = currentFacility.id;

	const { data: beneficiary } = useStoreQuery({
		selector: (state) => state.beneficiariesStore.beneficiary,
		stopOn: (value) => value !== null && value.id === beneficiaryId,
		query: () => {
			if (beneficiaryId === null) {
				return Promise.resolve();
			}

			return dispatch(fetchBeneficiary(new FetchBeneficiary(facilityId, beneficiaryId)));
		},
		deps: [beneficiaryId, facilityId],
	});

	return beneficiary !== null && beneficiary.id === beneficiaryId && !beneficiary.isArchived;
};

export default useIsBeneficiaryEditable;
